@if (isModal) {
  <sb-modal-header
    [modalTitle]="formTitle | translate"
    [headerClass]="mergeTabs ? 'secondary' : null"
    (onClose)="confirmClose()"
  ></sb-modal-header>
}
<ng-template #actions let-isTop="isTop">
  <div class="wizard__footer">
    <div>
      @if (dangerButton) {
        <sb-button
          buttonClass="danger"
          [message]="dangerButton.message"
          [size]="isTop ? 'sm' : null"
          [isDisabled]="dangerButton.isDisabled"
          [isLoading]="dangerButton.isLoading"
          (onClick)="clickDangerButton()"
        ></sb-button>
      }
    </div>
    <div>
      @if (showCancel) {
        <sb-button
          buttonClass="warning"
          message="SB_Cancel"
          [size]="isTop ? 'sm' : null"
          (onClick)="clickCancelButton()"
        ></sb-button>
      }
      @if (secondaryButton) {
        <sb-button
          buttonClass="secondary"
          [message]="secondaryButton.message"
          [size]="isTop ? 'sm' : null"
          [isDisabled]="secondaryButton.isDisabled"
          [isLoading]="secondaryButton.isLoading"
          (onClick)="clickSecondaryButton()"
        ></sb-button>
      }
      @if (tabs?.length > 1 && !mergeTabs) {
        <sb-button
          buttonClass="info"
          type="button"
          (onClick)="toggleTab(-1)"
          [isDisabled]="backDisabled()"
          [size]="isTop ? 'sm' : null"
          message="SB_Back"
        ></sb-button>
      }
      @if (tabs?.length > 1 && !mergeTabs) {
        <sb-button
          buttonClass="info"
          type="button"
          (onClick)="toggleTab(1)"
          [isDisabled]="nextDisabled()"
          [size]="isTop ? 'sm' : null"
          message="SB_Next"
        ></sb-button>
      }
      <sb-button
        buttonClass="success"
        type="button"
        (onClick)="save()"
        [isDisabled]="saveDisabled()"
        [message]="saveLabel || 'SB_Save'"
        [size]="isTop ? 'sm' : null"
        [isLoading]="isSaving"
      ></sb-button>
    </div>
  </div>
</ng-template>
<div class="space-between">
  @if (!isModal && formTitle) {
    <h2 [innerHTML]="formTitle | translate" class="mb-5"></h2>
  }
  @if (hasTopActions) {
    <ng-container
      [ngTemplateOutlet]="actions"
      [ngTemplateOutletContext]="{ isTop: true }"
    ></ng-container>
  }
</div>
@if (tabs) {
  <div
    class="wizard"
    [ngClass]="{ 'modal-body pt-0': isModal, 'wizard-no-images': hideImages }"
    [hidden]="showLoadingMessage()"
    >
    @if (tabs.length > 1) {
      <div class="wizard__tabs" [hidden]="mergeTabs">
        @for (tab of tabs; track tab) {
          <div
            class="wizard__tabs__tab"
        [ngClass]="{
          active: activeTabId === tab.id,
          'wizard__tabs__tab--hidden': tab.isTemplateHidden,
          'wizard__tabs__tab--disabled': tab.isDisabled
        }"
            (click)="tab.isDisabled ? null : setTab(tab.id)"
            >
            <sb-icon
              name="{{ tab.iconName }}"
              [overrideStyle]="activeTabId === tab.id ? 'solid' : 'regular'"
              [overlayName]="tab.isDone && !hideChecks ? 'tickCircle' : ''"
              overlayOverrideStyle="solid"
              overlayCustomClass="tab-done"
            ></sb-icon>
            <span [innerHTML]="tab.name | translate" class="hidden-xs"></span>
            @if (tabs.length > 1) {
              <div class="tab-line"></div>
            }
          </div>
        }
      </div>
    }
    @if (wizardForm && tabs) {
      <div
        class="wizard__main"
        [ngClass]="{ 'wizard__main--single': hideImages || isFullWidthConfirmation() }"
        >
        @for (tab of tabs; track tab) {
          @if (!hideImages && activeTabId === tab.id && confirmationImageCheck()) {
            <div class="wizard__image hidden-xs">
              <div [inlineSVG]="tab.svg || (tab.isConfirmation ? 'new_entries' : '')" class="hidden-xs"></div>
            </div>
          }
        }
        <form [ngClass]="{ 'wizard__form--small': mergeTabs }" [formGroup]="wizardForm">
          @for (tab of tabs; track tab) {
            @if (mergeTabs || activeTabId === tab.id) {
              @if (tabs.length > 1) {
                <h2
                  class="wizard__tab-heading"
                  [ngClass]="mergeTabs ? 'wizard__tab-heading--small' : 'visible-xs'"
                  [innerHTML]="tab.name | translate"
                ></h2>
              }
              @if (tab.description) {
                <div class="mt-3 mb-5 p-large text-base">
                  <span [innerHTML]="tab.description | translate"></span>
                  @if (tab.descriptionTooltip) {
                    <sb-icon
                      class="ml-3 text-muted"
                      name="info"
                      overrideStyle="solid"
                      [ngbTooltip]="tab.descriptionTooltip | translate"
                      placement="bottom"
                    ></sb-icon>
                  }
                </div>
              }
              @if (wizardForm.get(tab.formGroupName)) {
                <fieldset [formGroupName]="tab.formGroupName">
                  @for (field of tab.fields; track field; let fieldIndex = $index) {
                    @if (showField(field)) {
                      <ng-template #extraFieldIcons let-validationState="validationState">
                        <sb-icon
                          [name]="validationState?.iconName"
                          [textClass]="validationState?.textClass"
                          [ngbTooltip]="validationState?.label | translate"
                        ></sb-icon>
                        @if (field.tooltip) {
                          <sb-icon
                            name="questionCircle"
                            override-style="solid"
                            [ngbTooltip]="field.tooltip | translate"
                            class="text-muted ml-2"
                          ></sb-icon>
                        }
                      </ng-template>
                      @if (getControl(tab, field) || field.type?.isDecorative) {
                        <div
                          class="form-group {{ field.className + ' ' + (field.cols ? 'form-group-' + field.cols : '') }}"
                          id="formGroup-{{ parentDataId }}-{{ field.id }}"
                  [ngClass]="{
                    'form-group-decorative': field.type?.isDecorative,
                    'align-center': isFieldInline(field)
                  }"
                          >
                          @if (field.description) {
                            <div
                              class="mb-5 text-muted"
                              [innerHTML]="field.description | translate"
                            ></div>
                          }
                          @if (getControl(tab, field); as control) {
                            <div [ngClass]="{ 'align-center': isFieldInline(field) }">
                              @if (field.toggleMessage) {
                                <div class="mr-3">
                                  <sb-on-off-switch
                                    [label]="field.toggleMessage"
                                    [isChecked]="field.isToggledOn"
                                    (modelChange)="onToggle(tab, field, $event)"
                                  ></sb-on-off-switch>
                                </div>
                              }
                              <div
                                class="space-between transitionless-state"
                                [hidden]="field.toggleMessage && !field.isToggledOn"
                                >
                                <div class="align-center">
                                  @if (field.label && !field.type?.includesLabel) {
                                    <label for class="control-label">
                                      {{ field.label | translate }}
                                      <span class="pl-2">
                                        @if (!isFieldInline(field) && !field.type.isReadOnly) {
                                          <ng-container
                                *ngTemplateOutlet="
                                  extraFieldIcons;
                                  context: { validationState: getFieldValidationState(tab, field) }
                                "
                                          ></ng-container>
                                        }
                                      </span>
                                    </label>
                                  }
                                </div>
                              </div>
                              <div [hidden]="isHiddenByToggle(field)">
                                @if (field.type?.isText) {
                                  <div class="space-between">
                                    <div class="flex-grow" [ngClass]="{ 'input-group': field.type?.addon }">
                                      @if (field.type?.addon) {
                                        <span class="input-group-addon" id="{{ field.id }}-addon">
                                          @if (field.type !== formElements.Tel) {
                                            <span [innerText]="field.type?.addon"></span>
                                          }
                                        </span>
                                      }
                                      <input
                                        [type]="field.type?.typeLabel"
                                        class="form-control"
                                        [name]="field.id"
                                        [attr.disabled]="disabledAttrValue(!enableField(field))"
                                        placeholder="{{ field.placeholder | translate }}"
                                        [formControlName]="field.id"
                                        [maxlength]="field.maxlength"
                                        [min]="field.min"
                                        [max]="field.max"
                                        />
                                      </div>
                                      @if (field.type === formElements.Url) {
                                        <div>
                                          <button
                                            class="btn btn-link btn-auto"
                            [attr.disabled]="
                              disabledAttrValue(
                                !getValue(tab, field) || (wizardForm.controls && wizardForm.controls[field.id]?.invalid)
                              )
                            "
                                            (click)="openUrl(getValue(tab, field))"
                                            >
                                            <sb-icon name="followLink"></sb-icon>
                                          </button>
                                        </div>
                                      }
                                      @if (field.type === formElements.Twitter) {
                                        <div>
                                          <button
                                            class="btn btn-link btn-auto"
                            [attr.disabled]="
                              disabledAttrValue(
                                !getValue(tab, field) || (wizardForm.controls && wizardForm.controls[field.id]?.invalid)
                              )
                            "
                                            (click)="openTwitterHandle(getValue(tab, field))"
                                            >
                                            <sb-icon name="followLink"></sb-icon>
                                          </button>
                                        </div>
                                      }
                                    </div>
                                  }
                                  @if (field.type === formElements.SimpleSelect) {
                                    <select
                                      [formControlName]="field.id"
                                      [attr.disabled]="disabledAttrValue(field.isDisabled)"
                                      [required]="field.isRequired"
                                      [hidden]="optionsLoading(field)"
                                      class="form-control"
                                      >
                                      <option
                                        [attr.disabled]="disabledAttrValue(isFieldRequired(field))"
                                        [innerHTML]="'SB_Select' | translate"
                                        [ngValue]="null"
                                      ></option>
                                      @for (option of field.options; track option) {
                                        <option
                                          [innerHTML]="option[field.labelProp || 'name'] | translate"
                                          [ngValue]="option[field.idProp || 'id']"
                                          [attr.disabled]="disabledAttrValue(option.isDisabled)"
                                        ></option>
                                      }
                                    </select>
                                  }
                                  @if (field.type === formElements.Tel) {
                                    <sb-telephone-input
                                      [model]="getValue(tab, field)"
                                      [dialCountry]="data[field.relatedFieldId]"
                                      [isDisabled]="!enableField(field)"
                                      [fieldId]="field.id"
                                      [parentId]="parentDataId?.toString()"
                                      [form]="getFormGroup(tab.formGroupName)"
                                    ></sb-telephone-input>
                                  }
                                  @if (field.type?.isVisualSelect) {
                                    <sb-select
                                      [model]="getValue(tab, field)"
                                      [preset]="field.type"
                                      [selectOptions]="getFieldEnabledOptions(field)"
                                      [isDisabled]="!enableField(field)"
                                      [id]="field.id"
                                      [labelProp]="field.labelProp"
                                      [idProp]="field.idProp"
                                      [isGrid]="field.isGrid"
                                      [primaryOptionIds]="field.primaryOptionIds"
                                      [isColourIcons]="field.isColourIcons"
                                      [form]="getFormGroup(tab.formGroupName)"
                                      [hidden]="optionsLoading(field)"
                                      (onChange)="onVisualSelectChange(tab, field, $event.value)"
                                    ></sb-select>
                                  }
                                  @if (optionsLoading(field)) {
                                    <sb-loading class="text-muted"></sb-loading>
                                  }
                                  @if (field.options?.length === 0 && !field.emptyOptionsMessage) {
                                    <div
                                      [innerHTML]="'SB_Shared_SelectOption_NoOptionsAvailable' | translate"
                                    ></div>
                                  }
                                  @if (field.type === formElements.Switch) {
                                    <div
                                      [ngClass]="{ 'pt-2': !field.isInline && !field.noPadding }"
                                      >
                                      <sb-on-off-switch
                                        [isDisabled]="false"
                                        [isChecked]="getValue(tab, field)"
                                        [id]="field.id"
                                        [trueLabel]="field.trueLabel"
                                        [falseLabel]="field.falseLabel"
                                        [isDisabled]="!enableField(field)"
                                        (modelChange)="updateValue(tab, field, $event)"
                                        [ngClass]="{ 'p-2': !field.noPadding }"
                                        >
                                      </sb-on-off-switch>
                                    </div>
                                  }
                                  @if (field.type === formElements.Radio) {
                                    <div
                                      class="pt-2 align-center"
                                      [ngClass]="{ 'disabled-area': !enableField(field) }"
                                      >
                                      @for (option of field.options; track option) {
                                        <label class="align-center mr-4 mb-0">
                                          <input
                                            type="radio"
                                            [name]="field.id"
                                            [checked]="getValue(tab, field) === option[field.idProp || 'id']"
                                            [disabled]="!enableField(field)"
                                            (change)="updateValue(tab, field, option[field.idProp || 'id'])"
                                            />
                                          <span
                                            class="pl-2"
                                            [innerHTML]="option[field.labelProp || 'name'] | translate"
                                          ></span>
                                        </label>
                                      }
                                    </div>
                                  }
                                  @if (field.type === formElements.Colours) {
                                    <sb-colour-picker
                                      [colourOptions]="getValue(tab, field)"
                                      (colourOptionsChange)="updateValue(tab, field, $event)"
                                    ></sb-colour-picker>
                                  }
                                  @if (field.type === formElements.Content) {
                                    <sb-textarea
                                      [placeholder]="field.placeholder"
                                      id="{{ field.id }}"
                                      [height]="field.height"
                                      [maxLength]="field.maxlength"
                                      [rows]="field.rows"
                                      class="mt-2"
                                      [editorConfig]="field.editorConfig"
                                      [ngClass]="{ 'disabled-area': !enableField(field) }"
                                      [form]="getFormGroup(tab.formGroupName)"
                                      (modelChange)="updateValue(tab, field, $event)"
                                      />
                                  }
                                  @if (field.type === formElements.CheckboxList) {
                                    <div
                                      class="sb-grid p-2"
                                      [ngClass]="{ 'disabled-area': !enableField(field) }"
                                      >
                                      @for (option of field.options; track option; let optionIndex = $index) {
                                        <div class="align-center">
                                          @if (!option.isHidden) {
                                            <sb-check-box
                                              [isChecked]="getValue(tab, field)?.includes(option.id)"
                                              [controlName]="field.id"
                                              [label]="option.name"
                                              (modelChange)="onCheckBoxChanged(tab, field, option, $event)"
                                            ></sb-check-box>
                                          }
                                        </div>
                                      }
                                    </div>
                                  }
                                  @if (field.type === formElements.ButtonGroup) {
                                    <div class="pt-3">
                                      <div [ngClass]="{ 'btn-group': field.isGroup !== false }" role="group">
                                        @for (option of field.options; track option) {
                                          <button
                                            type="button"
                                            [ngClass]="getButtonClass(tab, field, option)"
                                            id="{{ field.id }}-{{ option.id }}"
                                            [attr.disabled]="disabledAttrValue(option.isDisabled || !enableField(field))"
                                            >
                                            <div class="w-100 align-center">
                                              @if (option.iconName) {
                                                <sb-icon
                                                  class="mr-3 p-large"
                                                  name="{{ option.iconName }}"
                                                  [overrideStyle]="getValue(tab, field) === option.id ? 'solid' : 'light'"
                                                ></sb-icon>
                                              }
                                              <span [innerHTML]="option.name | translate"></span>
                                            </div>
                                          </button>
                                        }
                                      </div>
                                    </div>
                                  }
                                  @if (field.type === formElements.Users) {
                                    <div class="mt-4" [hidden]="isHiddenByToggle(field)">
                                      <div class="space-between text-base mb-5">
                                        <h2 [innerHTML]="field.label || 'Select users' | translate"></h2>
                                        @if (field.isToggledOn) {
                                          <sb-button
                                            buttonClass="link"
                                            iconName="close"
                                            iconClasses="text-muted"
                                            (onClick)="field.isToggledOn = false"
                                          ></sb-button>
                                        }
                                      </div>
                                      <ng1-multi-person-picker
                                        [selectedPersonIds]="getValue(tab, field) || []"
                                        (selectedPersonIdsChange)="updateAndProvide(tab, field, $event)"
                                        [showOkButton]="false"
                                        [includePupils]="field.subTypeIds.includes(memberTypes.Student.id)"
                                        [includeStaff]="field.subTypeIds.includes(memberTypes.Staff.id)"
                                        [includeParents]="field.subTypeIds.includes(memberTypes.Parent.id)"
                                        [hideGroupFilter]="!field.subTypeIds.includes(memberTypes.Student.id)"
                                        [hideYearFilter]="!field.subTypeIds.includes(memberTypes.Student.id)"
                                        [lockedPersonId]="field.lockedItemId"
                                      ></ng1-multi-person-picker>
                                    </div>
                                  }
                                  @if (field.type === formElements.UserGroupings) {
                                    <sb-team-club-picker
                                      [showSubjects]="showSubjects"
                                      [model]="getValue(tab, field)"
                                      (modelChange)="updateValue(tab, field, $event)"
                                    ></sb-team-club-picker>
                                  }
                                  @if (field.type?.isMultiSelectComponent) {
                                    <div
                                      class="align-center"
                                      [ngClass]="{ 'multiselect-single-container': !field.isMultiOption }"
                                      [hidden]="optionsLoading(field)"
                                      >
                                      <ng-container>
                                        <ng-container>
                                          @if (getFieldEnabledOptions(field)?.length && field.dropdownSettings) {
                                            <sb-multiselect-dropdown
                                              [singleSelection]="!field.isMultiOption"
                                              [settings]="field.dropdownSettings"
                                              [placeholder]="getMultiSelectPlaceholder(tab, field)"
                                              [data]="getFieldEnabledOptions(field)"
                                              [model]="getValue(tab, field)"
                                              [disabled]="!enableField(field)"
                                              [reformat]="true"
                                              (modelChange)="updateValue(tab, field, $event)"
                                              (onClick)="setFieldAsTouched(tab, field)"
                                              class="flex-grow"
                                            ></sb-multiselect-dropdown>
                                          }
                                          @if (field.type === formElements.SearchAdd && field.subWizardConfig?.subWizardTabs) {
                                            <sb-button
                                              iconName="edit"
                                              [isAutoSize]="true"
                                              [isDisabled]="!getValue(tab, field)"
                                              buttonClass="link"
                                              (onClick)="openSubWizard(field, getValue(tab, field))"
                                              tooltipText="SB_Edit"
                                              tooltipPlacement="bottom"
                                              class="ml-3"
                                            ></sb-button>
                                          }
                                          @if (field.type === formElements.SearchAdd && field.subWizardConfig?.subWizardTabs) {
                                            <sb-button
                                              iconName="plus"
                                              [isAutoSize]="true"
                                              buttonClass="link"
                                              (onClick)="openSubWizard(field)"
                                              tooltipText="SB_Add"
                                              tooltipPlacement="bottom"
                                              class="ml-3"
                                            ></sb-button>
                                          }
                                        </ng-container>
                                      </ng-container>
                                      @if (!field.options?.length && field.emptyOptionsMessage) {
                                        <div
                                          [innerHTML]="field.emptyOptionsMessage | translate"
                                          class="form-group_empty-message"
                                        ></div>
                                      }
                                    </div>
                                  }
                                  @if (field.type === formElements.Currency && !field.isDisabled) {
                                    <sb-currency-input
                                      [form]="getFormGroup(tab.formGroupName)"
                                      [id]="field.id"
                                      [allowZero]="field.allowZero" [allowEmpty]="field.allowEmpty"
                                      [model]="getValue(tab, field)"
                                    ></sb-currency-input>
                                  }
                                  @if (field.type === formElements.Currency && field.isDisabled) {
                                    <sb-text
                                      customClasses="text-primary semi-bold"
                                      [message]="getFieldConfirmationValue(field)"
                                    ></sb-text>
                                  }
                                  @if (field.type === formElements.RecordType && field.options) {
                                    <sb-record-type-selector
                                      [options]="field.options"
                                      [id]="field.id"
                                      [form]="getFormGroup(tab.formGroupName)"
                                      [model]="getValue(tab, field)"
                                    ></sb-record-type-selector>
                                  }
                                  @if (field.type?.isDatePicker) {
                                    <div>
                                      @if (field.type?.isSingleDate && field.type?.hasTime) {
                                        <sb-date-range-picker
                                          [startDate]="getValue(tab, field)?.startDate"
                                          [minDate]="field.dateRangeLimit?.minLimit?.limitValue"
                                          [singleDatePicker]="true"
                                          [timePicker]="true"
                                          [autoUpdate]="true"
                                          [disabled]="!enableField(field)"
                                          (onChange)="onDatePickerChange(tab, field, $event)"
                                        ></sb-date-range-picker>
                                      }
                                      @if (field.type?.isSingleDate && !field.type?.hasTime) {
                                        <sb-single-date-picker
                                          [date]="getValue(tab, field)?.startDate"
                                          [minDate]="field.dateRangeLimit?.minLimit?.limitValue"
                                          [maxDate]="field.dateRangeLimit?.maxLimit?.limitValue"
                                          [disabled]="!enableField(field)"
                                          (onChange)="onDatePickerChange(tab, field, $event)"
                                        ></sb-single-date-picker>
                                      }
                                      @if (!field.type?.isSingleDate) {
                                        <sb-date-range-picker
                                          [startDate]="getValue(tab, field)?.startDate"
                                          [endDate]="getValue(tab, field)?.endDate"
                                          [minDate]="field.dateRangeLimit?.minLimit?.limitValue"
                                          [maxDate]="field.dateRangeLimit?.maxLimit?.limitValue"
                                          [singleDatePicker]="false"
                                          [timePicker]="field.type?.hasTime"
                                          [autoUpdate]="true"
                                          [disabled]="!enableField(field)"
                                          (onChange)="onDatePickerChange(tab, field, $event)"
                                        ></sb-date-range-picker>
                                      }
                                    </div>
                                  }
                                  @if (field.type === formElements.Time) {
                                    <div class="align-center">
                                      <ngb-timepicker [formControlName]="field.id" [spinners]="false"></ngb-timepicker>
                                      <div class="pl-3 text-muted">(24h)</div>
                                    </div>
                                  }
                                  @if (field.type === formElements.Summary) {
                                    <div class="flex">
                                      <sb-button
                                        [buttonClass]="field.buttonClass || 'default'"
                                        [message]="field.buttonMessage || 'SB_Edit'"
                                        [isDisabled]="field.isDisabled"
                                        (onClick)="showRelatedField(tab, field)"
                                      ></sb-button>
                                      <div class="pl-4 pt-2 text-base">
                                        @for (item of getValue(tab, field) || []; track item) {
                                          <div [innerHTML]="item.name"></div>
                                        }
                                        <input hidden [formControlName]="field.id" />
                                      </div>
                                    </div>
                                  }
                                  @if (field.type === formElements.IconList) {
                                    <div>
                                      @if (field.iconList.length === 0) {
                                        <sb-text [message]="field.defaultValue"></sb-text>
                                      }
                                      @for (icon of field.iconList; track icon) {
                                        <sb-icon
                                          [name]="icon.name"
                                          [altText]="icon.tooltip"
                                          [size]="icon.size"
                                          [ngClass]="icon.class"
                                          class="mr-2"
                                        ></sb-icon>
                                      }
                                    </div>
                                  }
                                  @if (field.type === formElements.BackgroundSettings) {
                                    <div>
                                      <div class="bg-options">
                                        @for (option of field.backgroundOptions; track option) {
                                          <label>
                                            <input
                                              type="radio"
                                              name="background"
                                              [value]="option.id"
                                              [checked]="option.id === data[field.id]"
                                              (change)="onBackgroundChange(option, field)"
                                              />
                                              <img [src]="cdnBase + option.imagePath" alt="" class="bg-thumbnail" />
                                            </label>
                                          }
                                        </div>
                                      </div>
                                    }
                                    @if (field.type === formElements.Readonly) {
                                      <div>
                                        <sb-text
                                          [textClass]="field.uiClassName"
                                          [customClasses]="field.className"
                                          [message]="getFieldConfirmationValue(field)"
                                          [icon]="field.icon"
                                        ></sb-text>
                                      </div>
                                    }
                                    @if (field.type === formElements.Badge) {
                                      <sb-badge
                                        [message]="getFieldConfirmationValue(field)"
                                        [badgeClass]="field.uiClassName"
                                      ></sb-badge>
                                    }
                                  </div>
                                  @if (isFieldInline(field)) {
                                    <div class="ml-4" [ngClass]="{ invisible: field.isToggledOn === false || field.type.isReadOnly }">
                                      <ng-container
                          *ngTemplateOutlet="
                            extraFieldIcons;
                            context: { validationState: getFieldValidationState(tab, field) }
                          "
                                      ></ng-container>
                                    </div>
                                  }
                                </div>
                              }
                              @if (field.type === formElements.SubHeading) {
                                <h2
                                  [innerHTML]="field.label | translate"
                                  [ngClass]="{ 'mt-5': fieldIndex !== 0 }"
                                ></h2>
                              }
                              @if (field.type === formElements.Paragraph) {
                                <sb-text
                                  [textClass]="field.uiClassName"
                                  [customClasses]="field.className"
                                  >
                                  <p [innerHTML]="field.label | translate"></p>
                                </sb-text>
                              }
                              @if (field.type === formElements.Alert) {
                                <sb-alert
                                  [message]="field.label"
                                  [alertClass]="field.uiClassName"
                                  [isSmall]="true"
                                  [isTextOnly]="true"
                                ></sb-alert>
                              }
                              @if (field.type === formElements.Arrow) {
                                <sb-icon
                                  name="arrow-right"
                                  size="xl"
                                  class="wizard__arrow"
                                ></sb-icon>
                              }
                              @if (field.type === formElements.Data) {
                                <div
                                  class="sb-grid {{ field.className }}"
                                  ng-style="getDataStyle(field)"
                                  >
                                  @for (element of field.elements; track element) {
                                    <div
                                      [innerHTML]="element.html | translate"
                                      [ngClass]="element.class"
                                    ></div>
                                  }
                                </div>
                              }
                              @if (field.type === formElements.Button) {
                                <sb-button
                                  [buttonClass]="field.buttonClass"
                                  [message]="field.label"
                                  [xsIconOnly]="field.xsIconOnly"
                                  [isDisabled]="!enableField(field)"
                                  (onClick)="buttonClick(field.id)"
                                  [buttonId]="parentDataId + '-' + field.id"
                                ></sb-button>
                              }
                              <div
                                [ngClass]="{ invisible: !getValidationMessage(tab, field) }"
                                class="validation"
                                [innerHTML]="getValidationMessage(tab, field)"
                              ></div>
                              @if (field.patternList) {
                                <div [ngClass]="{ 'text-muted': !isFieldTouched(tab, field) }">
                                  @for (item of getFormattedRuleList(tab, field); track item) {
                                    <div
                                      class="align-center"
                                      [ngClass]="{ 'text-success': item.isComplete }"
                                      >
                                      <sb-icon [name]="item.isComplete ? 'tickCircle' : 'crossCircle'"></sb-icon>
                                      <div [innerHTML]="item.label | translate" class="ml-2"></div>
                                    </div>
                                  }
                                </div>
                              }
                              @if (field.type?.manualValidation) {
                                <input
                                  hidden
                                  [formControlName]="field.id"
                                  [value]="getValue(tab, field)"
                                  [name]="field.id"
                                  />
                              }
                            </div>
                          }
                          @if (field.type === formElements.GameSummary) {
                            <sb-game-summary
                              [data]="data"
                              [dataTabs]="tabs"
                              [size]="tab.isConfirmation ? 'md' : 'lg'"
                            ></sb-game-summary>
                          }
                          @if (field.type === formElements.Kit) {
                            <sb-kit
                              [kitStyleId]="data[field.secondaryIds[1]]"
                              [primaryColour]="data[field.secondaryIds[2]]?.primaryColour"
                              [secondaryColour]="data[field.secondaryIds[2]]?.secondaryColour"
                              size="lg"
                            ></sb-kit>
                          }
                          @if (field.note) {
                            <div [innerHTML]="field.note | translate" class="wizard__note"></div>
                          }
                        }
                      }
                    </fieldset>
                  }
                }
              }
            </form>
            <ng-content></ng-content>
            <ng-template #confirmation let-tabs="tabs" let-subWizardData="subWizardData">
              <div class="wizard__confirmation">
                @for (tab of tabs; track tab) {
                  @if (!tab.isConfirmation && !tab.skipConfirmation && !isTabHidden(tab)) {
                    <div class="card w-100">
                      <div class="wizard__confirmation__section-heading">
                        <sb-icon [name]="tab.iconName" overrideStyle="light"></sb-icon>
                        <h3 [innerHTML]="tab.name | translate"></h3>
                      </div>
                      <div class="wizard__confirmation__section-block">
                        @for (field of tab.fields; track field) {
                          @if (!field.type?.isDecorative && !field.skipConfirmation && showField(field)) {
                            <div class="semi-bold" [innerHTML]="field.label || tab.name | translate"></div>
                            @if (!field.subWizardData) {
                              <div [innerHTML]="getFieldConfirmationValue(field) | translate"></div>
                            }
                          }
                        }
                      </div>
                    </div>
                  }
                }
              </div>
            </ng-template>
            @for (tab of tabs; track tab) {
              @if (tab.id === activeTabId && tab.isConfirmation) {
                <ng-container *ngTemplateOutlet="confirmation; context: { tabs: tabs }"></ng-container>
              }
            }
            <ng-content></ng-content>
          </div>
        }
        <ng-container [ngTemplateOutlet]="actions"></ng-container>
      </div>
    }
    @if (showLoadingMessage()) {
      <div class="loading-message">
        <sb-icon [name]="loadingMessage.iconName" overrideStyle="duotone"></sb-icon>
        <sb-text [message]="loadingMessage.message"></sb-text>
        <sb-loading></sb-loading>
      </div>
    }
    @if (isSavingSubWizard) {
      <div class="justify-center p-5">
        <sb-loading [message]="subWizardField.subWizardConfig?.subWizardSavingMessage || 'Saving record'"></sb-loading>
      </div>
    }
    <ng-template #subWizard let-modal>
      @if (!isLoadingSubWizardRecord && subWizardField?.subWizardConfig?.subWizardTabs) {
        <sb-wizard
          [isModal]="true"
          [formTitle]="subWizardTitle"
          [(tabs)]="subWizardField.subWizardConfig.subWizardTabs"
          [hideImages]="true"
          [mergeTabs]="true"
          [parentData]="subWizardData"
          [discardTitle]="subWizardField.subWizardConfig.subWizardDiscardTitle"
          [discardMessage]="subWizardRecordId ? 'Discard changes?' : subWizardField.subWizardConfig.subWizardDiscardMessage"
          [isLoading]="isLoadingSubWizardRecord"
          (onSave)="saveSubWizard($event, modal)"
          (onClose)="closeSubWizard(modal)"
        ></sb-wizard>
      }
      <sb-loading [hasLoaded]="!isLoadingSubWizardRecord"></sb-loading>
    </ng-template>
    <sb-confirm-dialog></sb-confirm-dialog>
